import CheckboxBlankCircleOutlineIcon from 'mdi-react/CheckboxBlankCircleOutlineIcon'
import CheckboxBlankOutlineIcon from 'mdi-react/CheckboxBlankOutlineIcon'
import CheckboxMarkedCircleOutlineIcon from 'mdi-react/CheckboxMarkedCircleOutlineIcon'
import CheckboxMarkedOutlineIcon from 'mdi-react/CheckboxMarkedOutlineIcon'

export const getCheckboxIcon = ({
  isSelected,
  isMultipleChoice,
}: {
  isSelected: boolean
  isMultipleChoice?: boolean
}) => {
  let Icon = CheckboxBlankCircleOutlineIcon

  if (isMultipleChoice) {
    if (isSelected) {
      Icon = CheckboxMarkedOutlineIcon
      return Icon
    }

    Icon = CheckboxBlankOutlineIcon
    return Icon
  }

  if (isSelected) {
    Icon = CheckboxMarkedCircleOutlineIcon
  }

  return Icon
}
